// Swiper 7.4.1
import './vendor/swiper';
import './vendor/focus-visible-polyfill';
import './vendor/gsap.min';
import './vendor/js.cookie.min';
